import $api from "@/frontend/shared/api/axios";

export async function getFileUrl({ fileId }: { fileId: number }) {
  const response = await $api.get(`/founders/data-room/files/${fileId}`);
  return response.data.data.secureUrl;
}
